import { Component } from '@angular/core';
import { TrialStatus, UserAssignedTrialStatus } from '@app/+state/trials/trials.model';
import { ITooltipConfig, TooltipDirective, TooltipPosition } from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-status-renderer',
  templateUrl: './ag-status-renderer.component.html',
  styleUrls: ['./ag-status-renderer.component.scss'],
  imports: [TooltipDirective],
})
export class AgStatusRendererComponent {
  TRIAL_STATUS = TrialStatus;
  USER_ASSIGNED_TRIAL_STATUS = UserAssignedTrialStatus;
  readonly tooltipConfig: ITooltipConfig = { position: TooltipPosition.Top, maxWidth: 400 };
  private params: any;

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
  agInit(params: any): void {
    this.params = params;
  }

  get Status(): TrialStatus {
    return this.params?.data.status?.toLowerCase();
  }

  constructor() {}
}
